import { render } from "./Language.vue?vue&type=template&id=7f0b0d18&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"

import "./Language.vue?vue&type=style&index=0&id=7f0b0d18&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1621785964/src/bitbucket.org/hotelkey/hotelkeyapp.com-v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0b0d18"]])

export default __exports__